import { getLanguage } from "../../../../../utils/index.js";
import { TRACK_TYPE_MULTI_ATTR } from "../../../../Analytics/constants.js";
const parseTrackingEvents = (xmlStr) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlStr, "application/xml");
  const parserError = xmlDoc.getElementsByTagName("parsererror");
  if (parserError.length > 0) {
    console.error("Error parsing XML:", parserError[0].textContent);
    return {};
  }
  const trackingElements = xmlDoc.getElementsByTagName("Tracking");
  const videoSrc = (_d = (_c = (_b = (_a = xmlDoc.getElementsByTagName("MediaFile")) == null ? void 0 : _a[0]) == null ? void 0 : _b.firstChild) == null ? void 0 : _c.textContent) == null ? void 0 : _d.trim();
  const captions = (_g = (_f = (_e = xmlDoc.getElementsByTagName("ClosedCaptionFile")) == null ? void 0 : _e[0]) == null ? void 0 : _f.textContent) == null ? void 0 : _g.trim();
  const redirectUrl = (_j = (_i = (_h = xmlDoc.getElementsByTagName("ClickThrough")) == null ? void 0 : _h[0]) == null ? void 0 : _i.textContent) == null ? void 0 : _j.trim();
  const trackingEvents = {};
  Array.from(trackingElements).forEach((tracking) => {
    var _a2;
    const event = tracking.getAttribute("event");
    const eventBeacon = (_a2 = tracking == null ? void 0 : tracking.textContent) == null ? void 0 : _a2.trim();
    trackingEvents[event] = eventBeacon;
  });
  return { trackingEvents, videoSrc, captions, redirectUrl };
};
const getVideoBeacons = async (url, trackEvent) => {
  let responseObj = {};
  let beaconObj = {};
  try {
    let finalUrl = url;
    if (!url.includes("https")) {
      finalUrl = `https:${url}`;
    }
    const VASTAnalyticXML = await fetch(finalUrl);
    const text = await VASTAnalyticXML.text();
    responseObj = parseTrackingEvents(text) || {};
    beaconObj = responseObj == null ? void 0 : responseObj.trackingEvents;
  } catch (error) {
    console.error("error vast", error);
    throw new Error("Error getting VASTAnalytics");
  }
  return {
    videoInformation: {
      src: responseObj == null ? void 0 : responseObj.videoSrc,
      captions: responseObj == null ? void 0 : responseObj.captions,
      redirectUrl: responseObj == null ? void 0 : responseObj.redirectUrl
    },
    on25PercentComplete: () => (beaconObj == null ? void 0 : beaconObj.firstQuartile) && navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.firstQuartile),
    on50PercentComplete: () => (beaconObj == null ? void 0 : beaconObj.midpoint) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.midpoint)),
    on75PercentComplete: () => (beaconObj == null ? void 0 : beaconObj.thirdQuartile) && navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.thirdQuartile),
    on100PercentComplete: () => (beaconObj == null ? void 0 : beaconObj.complete) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.complete)),
    onMute: () => (beaconObj == null ? void 0 : beaconObj.mute) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.mute)),
    onPause: () => (beaconObj == null ? void 0 : beaconObj.pause) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.pause)),
    onResume: () => (beaconObj == null ? void 0 : beaconObj.resume) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.resume)),
    onStart: () => {
      trackEvent({
        trackType: TRACK_TYPE_MULTI_ATTR,
        trackedData: [
          {
            key: "videoLinkClick",
            value: 1
          }
        ]
      });
      (beaconObj == null ? void 0 : beaconObj.start) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.start));
    },
    onUnmute: () => (beaconObj == null ? void 0 : beaconObj.unmute) && (navigator == null ? void 0 : navigator.sendBeacon(beaconObj == null ? void 0 : beaconObj.unmute))
  };
};
const getVideoInformation = ({
  objVAST,
  placement,
  isDesktop,
  locale,
  variant = "default",
  trackEvent
}) => {
  const videoInformation = objVAST == null ? void 0 : objVAST.videoInformation;
  const renderingInformation = placement == null ? void 0 : placement.rendering;
  const renderingType = isDesktop || variant === "default" ? "" : "mobile_";
  let videoSrc;
  if (videoInformation == null ? void 0 : videoInformation.src) {
    videoSrc = videoInformation == null ? void 0 : videoInformation.src;
  }
  const videoClickHandler = () => {
    if (!!(videoInformation == null ? void 0 : videoInformation.redirectUrl)) {
      trackEvent({
        adItem: {
          style: "video",
          title: renderingInformation == null ? void 0 : renderingInformation[`${renderingType}background_video_alt_text`]
        },
        itemCuration: "criteo",
        title: "video spotlight",
        trackType: "ad"
      });
      (placement == null ? void 0 : placement.OnClickBeacon) && navigator.sendBeacon(placement == null ? void 0 : placement.OnClickBeacon);
      window.open(
        videoInformation == null ? void 0 : videoInformation.redirectUrl,
        renderingInformation == null ? void 0 : renderingInformation.optional_redirect_target
      );
    } else {
      console.error(
        "ClickThrough tag is undefined or empty in Criteo Video VAST file"
      );
    }
  };
  const videoPlayerOptions = {
    aspectRatio: variant === "default" ? "16:9" : "1:1",
    autoReplay: true,
    autoplay: true,
    controlBar: {
      customControlSpacer: false,
      fullscreenToggle: false,
      progressControl: false,
      remainingTimeDisplay: false
    },
    controls: true,
    fluid: true,
    muted: true,
    playsinline: true,
    responsive: true,
    sources: {
      src: videoSrc,
      type: "video/mp4"
    },
    tracks: [
      {
        kind: "captions",
        label: getLanguage(locale) === "en" ? "English" : "French",
        src: videoInformation == null ? void 0 : videoInformation.captions,
        srclang: getLanguage(locale)
      }
    ],
    userActions: {
      click: videoClickHandler
    }
  };
  return {
    legalText: renderingInformation == null ? void 0 : renderingInformation.optional_legal_text,
    options: videoPlayerOptions
  };
};
const getCarouselA11yInformation = (locale) => {
  var _a, _b;
  const ariaMap = {
    "en-ca": {
      carouselLabel: "Sponsored Products",
      productTileNumberSeparator: "of"
    },
    "en-us": {
      carouselLabel: "Sponsored Products",
      productTileNumberSeparator: "of"
    },
    "fr-ca": {
      carouselLabel: "Produits commandités",
      productTileNumberSeparator: "sur"
    }
  };
  const carouselLabel = (_a = ariaMap[locale]) == null ? void 0 : _a.carouselLabel;
  const productTileNumberSeparator = (_b = ariaMap[locale]) == null ? void 0 : _b.productTileNumberSeparator;
  return {
    carouselLabel,
    productTileNumberSeparator
  };
};
const getProductTileImageHeight = ({
  show_action_button,
  isTablet,
  isMobile
}) => {
  const heightOffset = show_action_button ? 40 : 0;
  let maxProductTileImageHeight = `${250 - heightOffset}px`;
  if (isTablet) {
    maxProductTileImageHeight = `${225 - heightOffset}px`;
  } else if (isMobile) {
    maxProductTileImageHeight = `${250 - heightOffset}px`;
  }
  return maxProductTileImageHeight;
};
export {
  getCarouselA11yInformation,
  getProductTileImageHeight,
  getVideoBeacons,
  getVideoInformation,
  parseTrackingEvents
};
